import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { iconButtonDriverFactory } from './IconButton.driver';
import { IconButton } from '.';
import { Favorite as FavoriteIcon } from '@wix/wix-ui-icons-common/on-stage';

describe('IconButton', () => {
  const createDriver = createRendererWithUniDriver(iconButtonDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<IconButton icon={<FavoriteIcon />} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should call onClick function', async () => {
    const onClick = jest.fn();
    const { driver } = createDriver(
      <IconButton icon={<FavoriteIcon />} onClick={onClick} />,
    );
    await driver.click();
    expect(onClick).toHaveBeenCalled();
  });
});
